<template>
    <div class="max-view-shell">
        <!-- 头部logo -->
        <head-tou/>
        <!-- 导航栏 -->
        <navi-gation ref="Childmain"/>
        <router-view @on-login="show_login" @on-reg="show_reg" @get-info="get_info"/>
        <keep-alive>
            <navigation-button @on-nav="cut_nav"/>
        </keep-alive>
    </div>
</template>

<script>
  import HeadTou from '@/components/hard.vue'
  import NavigationButton from '@/components/navigationbutton.vue'
  import NaviGation from '@/views/home/components/navigation.vue'

  export default {
    name: 'layout',
    components: {
      HeadTou,
      NavigationButton,
      NaviGation,
    },
    data () {
      return {}
    },
    methods: {
      get_info(){
        this.$refs.Childmain.getUserInfo()
      },
      show_login () {
        this.$refs.Childmain.on_login()
      },
      show_reg () {
        this.$refs.Childmain.on_reg()
      },
      cut_nav (index) {
        this.$refs.Childmain.cut_nav(index)
      }
    }
  }
</script>

<style lang="less" scoped>
    .max-view-shell {
        .max-content-shell {
            backgound-color: #f7f7f7;
        }
    }
</style>
